import { addCompareInit, checkCompare, updateIcon } from "./add"
import { compareSliderInit } from "./slider"
import { delCompareInit } from "./del"
import hermes from "hermes"

export const compareInit = () => {
  addCompareInit()
  checkCompare()
  compareSliderInit()
  delCompareInit()
  hermes.on("updateCompare", data => {
    updateIcon(data)
  })
}
